import {DrawerProps} from '@mantine/core';
import {useParams} from "react-router-dom";
import {FormDrawer} from "./FormDrawer.tsx";
import {usePlaybook} from "../hooks/usePlaybook.ts";


export const EditFormDrawer = (props: DrawerProps) => {

    const {id: playbookId} = useParams();

    if (typeof playbookId === 'undefined') {
        throw new Error('playbookId is required parameter');
    }

    const {
        record,
        updateRecord,
    } = usePlaybook(playbookId);

    if (!record) return null;

    return (
        <FormDrawer
            record={record}
            handleSubmit={updateRecord}
            {...props}
        />
    )
};


